
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { User } from '@supabase/supabase-js';

export const usePollVoting = (pollId: string) => {
  const [isVoting, setIsVoting] = useState(false);

  const handleVote = async (optionId: string, user: User | null, hasVoted: boolean, userVotedOption: any) => {
    if (!user) {
      toast.error('You need to be logged in to vote');
      return;
    }
    
    setIsVoting(true);
    
    try {
      // Check if user has already voted
      if (hasVoted && userVotedOption) {
        // Find the previous vote
        const previousVote = userVotedOption.votes?.find((vote: any) => vote.user_id === user.id);
        
        if (previousVote) {
          // Delete previous vote if voting for a different option
          if (userVotedOption.id !== optionId) {
            await supabase
              .from('poll_votes')
              .delete()
              .eq('id', previousVote.id);
            
            // Insert new vote
            await supabase
              .from('poll_votes')
              .insert({
                poll_option_id: optionId,
                user_id: user.id
              });
            
            toast.success('Your vote has been updated');
          }
        }
      } else {
        // Insert new vote
        await supabase
          .from('poll_votes')
          .insert({
            poll_option_id: optionId,
            user_id: user.id
          });
        
        toast.success('Vote recorded successfully');
      }
    } catch (error) {
      console.error('Error voting:', error);
      toast.error('Failed to record your vote');
    } finally {
      setIsVoting(false);
    }
  };

  return {
    isVoting,
    handleVote
  };
};
